module.exports = __webpack_public_path__ + "img/planeas-1-01.00050ee9.png";